import { buildType } from "@helpers/app-identity";
import { useAppStore } from "@hooks/useAppStore";
import { API_ENDPOINTS, PROD_API_BASE_URL } from "@memorang/constants/urls";
import { isWeb } from "@memorang/helpers/platform";
import * as SentryReact from "@sentry/react";
import * as SentryNative from "@sentry/react-native";
import { isSentryNoise } from "./sentry-noise-filter";

const isDev = process.env.NODE_ENV === "development";
export const reactNavigationIntegration =
	SentryNative.reactNavigationIntegration();

export const getSentryInstance = () => {
	if (isWeb) {
		return SentryReact;
	}
	return SentryNative;
};

const ALLOWED_NETWORK_URLS = [
	`${PROD_API_BASE_URL}${API_ENDPOINTS.ANSWER_EVENTS}`,
];

export const initSentry = () => {
	const currentAppVersion = useAppStore.getState().app?.version;
	const dsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
	if (isWeb) {
		if (!SentryReact.isInitialized()) {
			SentryReact.init({
				dsn,
				enabled: !isDev,
				// debug: isDev,
				environment: process.env.NODE_ENV,
				tracesSampleRate: 1.0,
				profilesSampleRate: 0.5,
				replaysSessionSampleRate: 0,
				replaysOnErrorSampleRate: isDev ? 0 : 1,
				beforeSend: (event, hint) =>
					isSentryNoise(event, hint) ? null : event,
				integrations: [
					SentryReact.replayIntegration({
						maskAllText: false,
						maskAllInputs: true,
						blockAllMedia: true,
						block: [".paywall", ".checkout", "[data-private]"],
						mask: ["[data-pii]"],
						networkDetailAllowUrls: ALLOWED_NETWORK_URLS,
						networkRequestHeaders: ["X-Custom-Header"],
						networkResponseHeaders: ["X-Custom-Header"],
						maxReplayDuration: 1000 * 600, // 10 minutes
					}),
					SentryReact.browserTracingIntegration(),
				],
			});
			SentryReact.setTag("app", buildType);
			SentryReact.setTag("version", currentAppVersion);
		}
	} else {
		SentryNative.init({
			dsn,
			enabled: !isDev,
			// debug: isDev,
			environment: process.env.NODE_ENV,
			tracesSampleRate: 1.0,
			profilesSampleRate: 1.0,
			integrations: [reactNavigationIntegration],
		});
		SentryNative.setTag("app", buildType);
		SentryNative.setTag("version", currentAppVersion);
	}
};

export const replayManager = () => {
	const replay = SentryReact.getReplay();

	return {
		startReplay: () => {
			if (replay && isWeb) {
				try {
					replay.start();
				} catch (error) {
					console.error("Failed to start replay:", error);
				}
			}
		},
		stopReplay: () => {
			if (replay && isWeb) {
				try {
					replay.stop();
				} catch (error) {
					console.error("Failed to stop replay:", error);
				}
			}
		},
	};
};
